<template>
  <div class="external-frame">
    <iframe
      ref="externalIframe"
      :src="externalUrl"
      frameborder="0"
      class="external-frame__iframe"
      @load="onIframeLoad"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: "ExternalFrame",

  data: () => ({
    externalUrl: "",
    externalOrigin: "",
  }),

  watch: {
    '$route'(to) {
      // Fecha a sidebar ao trocar entre links externos
      this.$store.commit("SET_DRAWER", false);
      
      // Atualiza a URL do iframe quando a rota muda
      const routePath = to.path.replace(/^\//, "");
      const baseUrl = this.getExternalUrl(routePath);
      
      if (baseUrl) {
        this.externalOrigin = this.getExternalOrigin(baseUrl);
        this.externalUrl = this.buildExternalUrl(baseUrl);
      } else {
        console.error("URL externa não encontrada para a rota:", routePath);
        this.$router.push("/modulos");
      }
    },
  },

  mounted() {
    // Fecha a sidebar ao abrir link externo
    this.$store.commit("SET_DRAWER", false);

    // Busca a URL do item de menu baseado na rota
    const routePath = this.$route.path.replace(/^\//, "");
    const baseUrl = this.getExternalUrl(routePath);

    if (!baseUrl) {
      console.error("URL externa não encontrada para a rota:", routePath);
      this.$router.push("/modulos");
      return;
    }

    this.externalOrigin = this.getExternalOrigin(baseUrl);
    this.externalUrl = this.buildExternalUrl(baseUrl);
    window.addEventListener("message", this.onWindowMessage);
  },

  methods: {
    getExternalUrl(routePath) {
      if (this.$route.meta && this.$route.meta.externalUrl) {
        return this.$route.meta.externalUrl;
      }

      // Importa os itens de navegação
      const { drawerItems } = require("@/config/navigationConfig");

      // Busca o item com a rota correspondente
      for (const item of drawerItems) {
        if (item.to === routePath && item.external && item.url) {
          return item.url;
        }
      }

      return null;
    },

    getExternalOrigin(url) {
      const metaOrigin = this.$route.meta && this.$route.meta.externalOrigin;
      if (metaOrigin) return metaOrigin;
      try {
        return new URL(url).origin;
      } catch (error) {
        return "";
      }
    },

    shouldBridgeAuth() {
      return Boolean(this.$route.meta && this.$route.meta.bridgeAuth);
    },

    buildExternalUrl(baseUrl) {
      if (!this.shouldBridgeAuth()) {
        return baseUrl;
      }

      const user = JSON.parse(sessionStorage.getItem("user") || "null");
      const token = user?.accessToken || user?.token || "";

      if (!token) {
        return baseUrl;
      }

      try {
        const parsedUrl = new URL(baseUrl);
        if (!parsedUrl.searchParams.get("token")) {
          parsedUrl.searchParams.set("token", token);
        }
        return parsedUrl.toString();
      } catch (error) {
        return baseUrl;
      }
    },

    getPortalAuthPayload() {
      const user = JSON.parse(sessionStorage.getItem("user") || "null");
      if (!user) return null;

      const accessToken = user.accessToken || user.token || "";
      const tokenType = user.tokenType || user.type || "Bearer";

      return {
        token: accessToken,
        type: tokenType,
        username: user.username || "",
        nome: user.nome || "",
        email: user.email || user.username || "",
        roles: Array.isArray(user.roles) ? user.roles : [],
        accessToken,
        tokenType,
      };
    },

    sendPortalAuth() {
      if (!this.shouldBridgeAuth() || !this.externalOrigin) {
        return;
      }

      const iframeWindow = this.$refs.externalIframe?.contentWindow;
      const payload = this.getPortalAuthPayload();
      if (!iframeWindow || !payload) {
        return;
      }

      iframeWindow.postMessage(
        {
          type: "PORTAL_AUTH",
          payload,
        },
        this.externalOrigin,
      );
    },

    onWindowMessage(event) {
      if (!this.shouldBridgeAuth() || !this.externalOrigin) {
        return;
      }
      if (event.origin !== this.externalOrigin) {
        return;
      }
      if (!event.data || event.data.type !== "FINANCEIRO_READY") {
        return;
      }
      this.sendPortalAuth();
    },

    onIframeLoad() {
      console.log("Iframe carregado:", this.externalUrl);
      this.sendPortalAuth();
    },
  },

  beforeDestroy() {
    window.removeEventListener("message", this.onWindowMessage);
    this.$store.commit("SET_DRAWER", true);
  },
};
</script>

<style scoped>
.external-frame {
  width: 100%;
  height: calc(100vh - 65px);
  overflow: hidden;
}

.external-frame__iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>
